import React from "react";
import CaixaLogo from "./CaixaLogo";

const FooterCaixaBank = () => {
  return (
    <footer className="bg-white border-t border-slate-200 mt-16">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 py-8">
        {/* Section copyright uniquement */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-3">
            {/* Étoile à gauche */}
            <CaixaLogo showStarOnly={true} size={40} variant="default" />
            <div>
              <p className="text-2xl font-bold text-[#007EAE]" style={{ fontFamily: "Georgia, serif" }}>
                CaixaBank
              </p>
              <p className="text-xs text-slate-600 mt-1">Votre confiance depuis 1904</p>
            </div>
          </div>
          <div className="text-xs text-slate-600">
            <p>&copy; {new Date().getFullYear()} CaixaBank. Tous droits réservés.</p>
            <p className="mt-1">CaixaBank, S.A., société anonyme de droit espagnol</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterCaixaBank;
